module.exports = __webpack_public_path__ + "static/pages_mobile-79057a7fdda85d8092a75b8075d51b00.webp";